// Sprint 34.0 — Utilidad de alertas sonoras de alto impacto (Web Audio API).
// Genera una sirena/timbre industrial fuerte y agudo, audible en entornos ruidosos.
// Se comparte entre la app del Valet y la Landing del cliente.

let _ctx = null;

function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!_ctx) {
    try { _ctx = new AC(); } catch { return null; }
  }
  if (_ctx.state === "suspended") {
    try { _ctx.resume(); } catch { /* noop */ }
  }
  return _ctx;
}

// Debe llamarse dentro de un gesto del usuario (click/tap) para desbloquear el
// audio en navegadores móviles y permitir que la sirena suene luego por polling/WS.
export function unlockAudio() {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    g.gain.value = 0.0001; // inaudible: solo "arma" el contexto
    o.connect(g);
    g.connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + 0.02);
  } catch { /* noop */ }
}

// Sirena de alto impacto: barridos ascendente/descendente con dos osciladores
// ásperos (sawtooth + square) a volumen alto. `wails` = número de gemidos.
export function playSiren({ wails = 3 } = {}) {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const now = ctx.currentTime;
    const master = ctx.createGain();
    master.gain.value = 0.9; // fuerte
    master.connect(ctx.destination);

    const o1 = ctx.createOscillator();
    const o2 = ctx.createOscillator();
    o1.type = "sawtooth";
    o2.type = "square";
    const g = ctx.createGain();
    g.gain.value = 0.0001;
    o1.connect(g);
    o2.connect(g);
    g.connect(master);

    const wail = 0.34; // duración de cada barrido
    let t = now;
    for (let i = 0; i < wails; i++) {
      // Barrido tipo sirena (sube y baja) — agudo y penetrante
      o1.frequency.setValueAtTime(900, t);
      o1.frequency.linearRampToValueAtTime(1800, t + wail / 2);
      o1.frequency.linearRampToValueAtTime(900, t + wail);
      o2.frequency.setValueAtTime(680, t);
      o2.frequency.linearRampToValueAtTime(1360, t + wail / 2);
      o2.frequency.linearRampToValueAtTime(680, t + wail);
      // Envolvente: golpe fuerte con caída
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.4, t + 0.03);
      g.gain.setValueAtTime(0.4, t + wail - 0.06);
      g.gain.exponentialRampToValueAtTime(0.0001, t + wail);
      t += wail + 0.05;
    }
    o1.start(now);
    o2.start(now);
    o1.stop(t + 0.05);
    o2.stop(t + 0.05);
    o1.onended = () => { try { master.disconnect(); } catch { /* noop */ } };
  } catch { /* audio no disponible */ }
}
